<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_question") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ $t("PLACEHOLDERS.choose_type") }}</h3>

            <div class="type-selector">
              <label
                v-for="type in questionTypes"
                :key="type.value"
                class="custom-radio"
                :class="{ selected: data.type === type.value, disabled: true }"
                :disabled="true"
              >
                <input
                  type="radio"
                  :value="type.value"
                  v-model="data.type"
                  :disabled="true"
                />
                <span class="radio-label">{{ $t(type.label) }}</span>
              </label>
            </div>
          </div>

          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.question')"
            v-model.trim="data.question"
            required
            :disabled="true"
          />
          <audio-upload
            class="mt-2 col-lg-6"
            v-model="data.audio"
            :preSelected="data.audio"
            @file-selected="handleAudioSelected"
            @file-removed="handleAudioRemoved"
            disabled
            :label="$t('PLACEHOLDERS.record')"
          />
          <div
            v-if="data.type === 'mcq' || data.type === 'multi_choice'"
            class="row"
          >
            <div
              v-for="(answer, idx) in 4"
              :key="idx"
              class="col-md-6 mb-2 d-flex align-items-start gap-2"
            >
              <template v-if="data.type === 'mcq'">
                <input
                  type="radio"
                  :name="'correctAnswer'"
                  :value="idx"
                  v-model="data.correctAnswer"
                  style="margin-right: 8px"
                  :disabled="true"
                />
              </template>
              <template v-else>
                <input
                  type="checkbox"
                  :value="idx"
                  v-model="data.correctAnswers"
                  style="margin-right: 8px"
                  :disabled="true"
                />
              </template>
              <base-text-editor
                :placeholder="$t(`PLACEHOLDERS.answer${idx + 1}`)"
                v-model.trim="data.answers[idx]"
                required
                style="flex: 1"
                disabled
              />
            </div>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.question_degree')"
              v-model.trim="data.questionDegree"
              required
              disabled
            />
          </div>

          <!-- Start:: True/False Type -->
          <div v-if="data.type === 'true_false'" class="row">
            <div class="col-md-6 mb-2 d-flex align-items-center gap-2">
              <label
                class="custom-radio"
                :class="{ selected: data.trueFalseAnswer === true }"
              >
                <input
                  type="radio"
                  name="trueFalseAnswer"
                  :value="true"
                  v-model="data.trueFalseAnswer"
                  disabled
                />
                <span class="radio-label">{{ $t("PLACEHOLDERS.true") }}</span>
              </label>
              <label
                class="custom-radio"
                :class="{ selected: data.trueFalseAnswer === false }"
              >
                <input
                  type="radio"
                  name="trueFalseAnswer"
                  :value="false"
                  disabled
                  v-model="data.trueFalseAnswer"
                />
                <span class="radio-label">{{ $t("PLACEHOLDERS.false") }}</span>
              </label>
            </div>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.question_degree')"
              v-model.trim="data.questionDegree"
              required
              disabled
            />
          </div>
          <!-- End:: True/False Type -->

          <!-- Start:: Match Type -->
          <div
            v-if="data.type === 'match' || data.type == 'orderd'"
            class="row justify-content-center"
          >
            <div
              class="col-lg-6 col-12"
              v-for="(pair, idx) in data.matchPairs"
              :key="'match' + idx"
            >
              <div class="item d-flex align-items-center gap-2">
                <base-input
                  class="w-100"
                  type="text"
                  :placeholder="
                    data.type == 'orderd'
                      ? $t('PLACEHOLDERS.ordered_phrase')
                      : $t('PLACEHOLDERS.match_question')
                  "
                  v-model.trim="pair.question"
                  disabled
                />
                <base-input
                  class="w-100"
                  :type="data.type == 'orderd' ? 'number' : 'text'"
                  :placeholder="
                    data.type == 'orderd'
                      ? $t('PLACEHOLDERS.ordered_order')
                      : $t('PLACEHOLDERS.match_answer')
                  "
                  v-model.trim="pair.answer"
                  disabled
                />
                <!-- <div class="all_actions" v-if="data.matchPairs.length > 2">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeMatchRow(idx)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div> -->
              </div>
            </div>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.question_degree')"
              v-model.trim="data.questionDegree"
              required
              disabled
            />
          </div>
          <!-- End:: Match Type -->

          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileUpload from "../../../components/formInputs/FileUpload.vue";
import AudioUpload from "../../../components/formInputs/AudioUpload.vue";

export default {
  name: "ShowBank",
  components: { FileUpload, AudioUpload },

  data() {
    return {
      isWaitingRequest: false,
      data: {
        type: "",
        question: "",
        correctAnswer: 0,
        correctAnswers: [],
        answers: ["", "", "", ""],
        audio: null,
        matchPairs: [],
        orderedPairs: [],
        trueFalseAnswer: null,
        questionDegree: "",
      

},
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
    questionTypes() {
      return [
        { value: "mcq", label: "PLACEHOLDERS.mcq" },
        { value: "match", label: "PLACEHOLDERS.match" },
        { value: "multi_choice", label: "PLACEHOLDERS.multi_choice" },
        { value: "true_false", label: "PLACEHOLDERS.true_false" },
        { value: "orderd", label: "PLACEHOLDERS.ordered" },
      ];
    },
  },

  methods: {
    handleAudioSelected(files) {
      this.selectedFiles = files;
    },
    handleAudioRemoved(index) {
      this.existingFiles.splice(index, 1);
    },
    async showExam() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `questions/${this.$route.params?.questionId}`,
        });
        const q = res.data.data.Question;
        this.data.type = q.type;
        this.data.question = q.question;
        this.data.questionDegree = q.question_mark;

        // MCQ & Multi Choice
        if (q.type === "mcq" || q.type === "multi_choice") {
          this.data.answers = q.answers.map((a) => a.answer);
          if (q.type === "mcq") {
            this.data.correctAnswer = q.answers.findIndex(
              (a) => a.is_correct == 1
            );
          } else {
            this.data.correctAnswers = q.answers
              .map((a, idx) => (a.is_correct == 1 ? idx : null))
              .filter((idx) => idx !== null);
          }
        }

        // True/False
        if (q.type === "true_false") {
          const trueIdx = q.answers.findIndex((a) => a.answer === "true");
          this.data.trueFalseAnswer = q.answers[trueIdx]?.is_correct == 1;
        }

        // Match
        if (q.type === "match") {
          const parents = q.answers.filter((a) => a.parent_id == null);
          this.data.matchPairs = parents.map((parent) => {
            const child = q.answers.find((a) => a.parent_id == parent.id);
            return {
              question: parent.answer,
              answer: child ? child.answer : "",
            };
          });
        }

        // Ordered
        if (q.type === "orderd" || q.type === "ordered") {
          console.log(q.answers, "aa");
          this.data.matchPairs = q.answers.map((ans) => {
            return {
              question: ans.answer,
              answer: ans ? ans.orderd : "",
            };
          });
        }

        // Audio/file
        this.data.audio = q.file || null;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showExam();
  },
};
</script>
